
<div class="dropdown">
    <span class="dd-title-test" *ngIf="label != ''" (click)="dropdownClick()" [class.red-text]="shouldBeRed()" [class.align-left]="alignLeft">{{label}}</span>
    <div class="selected-item" (click)="dropdownClick()">{{getSelection()}}
      <img alt="" class="small-triangle" [src]="getDownTriangleSrc()">
    </div>
    <div #dropdownContent class="dropdown-content" [class.right]="right">
  
      <div class="title">{{title}}</div>
      <div *ngIf="shouldBeRed()" class="reset" (click)="reset()">{{getString('resetFilter')}}</div>
      <span class="close-btn" (click)="closeDropdown()">&times;</span>
      <app-range-slider #rangeSlider
        [min]="constMinValue" [max]="constMaxValue"
        [minValue]="minValue" [maxValue]="maxValue"
        (onSlide)="rangeSliderChange($event)"></app-range-slider>

    </div>
  </div>
  